module.exports = __webpack_public_path__ + "static/media/training_6_mind_body_fitness.07799a16.webp";